export const ADMIN_TAB_LOCKS_STORAGE_KEY = "visaPortalAdminLockedTabs";
export const ADMIN_TAB_LOCKS_EVENT = "visa-portal-admin-tab-locks-changed";

export const SIDEBAR_TABS = [
  { name: "Dashboard", path: "/dashboard" },
  { name: "Roles", path: "/roles" },
  { name: "Permissions", path: "/permissions" },
  { name: "Agents", path: "/Agents" },
  { name: "Clients", path: "/Clients" },
  { name: "Assisted Bookings", path: "/AssistedBookings" },
  { name: "VFS", path: "/booking-details" },
  { name: "Available Slots", path: "/available-slots" },
  { name: "Booking Status", path: "/BookingStatusPage" },
  { name: "TLS", path: "/tls-form" },
  { name: "Extension License", path: "/extension-license" },
];

function normalizePath(path) {
  return String(path || "").trim().toLowerCase();
}

export function getLockedTabPaths() {
  try {
    const rawValue = localStorage.getItem(ADMIN_TAB_LOCKS_STORAGE_KEY);
    if (!rawValue) {
      return [];
    }

    const parsedValue = JSON.parse(rawValue);
    if (!Array.isArray(parsedValue)) {
      return [];
    }

    return parsedValue
      .map((path) => normalizePath(path))
      .filter(Boolean);
  } catch {
    return [];
  }
}

export function saveLockedTabPaths(paths) {
  const normalizedPaths = Array.from(new Set((paths || []).map((path) => normalizePath(path)).filter(Boolean)));
  localStorage.setItem(ADMIN_TAB_LOCKS_STORAGE_KEY, JSON.stringify(normalizedPaths));
  window.dispatchEvent(new Event(ADMIN_TAB_LOCKS_EVENT));
}

export function isTabLocked(path) {
  return getLockedTabPaths().includes(normalizePath(path));
}

export function getFirstUnlockedTabPath() {
  const lockedPaths = new Set(getLockedTabPaths());
  const firstUnlockedTab = SIDEBAR_TABS.find((tab) => !lockedPaths.has(normalizePath(tab.path)));
  return firstUnlockedTab ? firstUnlockedTab.path : null;
}

export function getTabLockState() {
  const lockedPaths = new Set(getLockedTabPaths());
  return SIDEBAR_TABS.map((tab) => ({
    ...tab,
    locked: lockedPaths.has(normalizePath(tab.path)),
  }));
}